import { createFileRoute, useSearch } from "@tanstack/react-router"
import { useEffect } from "react"
import { Skeleton } from "@/components/ui/skeleton.tsx"

export const Route = createFileRoute("/_unauthorized/auth/journalist")({
  component: RouteComponent,
})

function RouteComponent() {
  const { action }: { action?: string } = useSearch({
    from: "/_unauthorized/auth/journalist",
  })
  useEffect(() => {
    if (action === "signup") {
      window.location.replace(`/signup`)
    } else if (action === "login") {
      window.location.replace(`/login`)
    } else {
      window.location.replace(`/`)
    }
  }, [action])
  return (
    <div className="flex w-full flex-col gap-2">
      <Skeleton className="mb-4 h-8 w-full" />
      <Skeleton className="h-5 w-full" />
      <Skeleton className="h-5 w-full" />
      <Skeleton className="h-5 w-full" />
      <Skeleton className="mb-4 h-5 w-1/2" />
      <Skeleton className="h-5 w-full" />
      <Skeleton className="h-5 w-full" />
      <Skeleton className="h-5 w-full" />
      <Skeleton className="h-5 w-1/4" />
    </div>
  )
}
